/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { SysqueSystemCategoryOptionsComponent } from '../../sysque-system-category-options/sysque-system-category-options.component';
import { SystemOptions } from '../../models/system-options';
import { SysquePopupConfig } from '../../models/sysque-popup-config';
import { PopupDialog } from '../popup-dialog.interface';
import { GlobalConstants } from '../../constants/global-constants';

export class RenameSystemCategoryDialog implements PopupDialog {
  create(sysquePopupConfig: SysquePopupConfig, componentTitle?: string): any {
    sysquePopupConfig.component = SysqueSystemCategoryOptionsComponent;
    const systemOptions = new SystemOptions();
    systemOptions.buttonLabel = 'Apply';
    sysquePopupConfig.data = systemOptions;
    sysquePopupConfig.width = 505;
    if (componentTitle === GlobalConstants.RENAME_CATEGORY_NAME_DIALOG) {
      sysquePopupConfig.height = 200;
    } else {
      sysquePopupConfig.height = 240;
    }
    sysquePopupConfig.componentTitle = componentTitle;
  }
}
